import React from "react";
import { FieldValues } from "react-hook-form";
import TestSendingIntitialForm from "./TestSendingIntitialForm";
import TestSendingForm from "./TestSendingForm";

const TestSending = () => {
  const [initialData, setInitialData] = React.useState<FieldValues | null>(null);

  const handleInitialSubmit = (data: FieldValues) => {
    setInitialData(data);
  };

  return !initialData ? (
    <TestSendingIntitialForm onSubmit={handleInitialSubmit} />
  ) : (
    <TestSendingForm initialData={initialData} />
  );
};

export default TestSending;
